import { apiRequest } from './apiClient';

const BASE = '/api/cihaz-sorgulama';

/**
 * @param {{ seriNumarasi: string }} params
 */
export const fetchCihazSorgulama = async ({ seriNumarasi }) => {
  const q = String(seriNumarasi || '').trim();
  if (!q) {
    throw new Error('Seri numarası gereklidir');
  }
  return apiRequest(BASE, {
    method: 'GET',
    query: { seriNumarasi: q },
  });
};
